import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionTemporarilyDisabledTooltip = props => /*#__PURE__*/_jsx(UITooltip, Object.assign({
  placement: "bottom left"
}, props, {
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.actionTemporarilyDisabledTooltipText"
  })
}));
export default ActionTemporarilyDisabledTooltip;